import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex !important;
  flex-direction: row;
  margin-top: 5px;
  align-items: center;
`;

// SMALL

export const ActionsButtonCircularSmall = styled.a`
  height: 40px;
  width: 40px;
  background-color: #1c2042;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 2px;
`;

export const ActionsButtonTextSmall = styled.a`
  color: #f1d8dd;
  font-size: 30px;
  letter-spacing: -2.58px;
  line-height: 30px;
  margin-top: 5px;
  cursor: pointer;
  background-color: #1c2042;
  padding: 0 4px 6px 0;
`;

// MEDIUM

export const ActionsButtonCircularMedium = styled.a`
  height: 46px;
  width: 46px;
  background-color: #EFD6DB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 5px;
`;

export const ActionsButtonTextMedium = styled.a`
  color: #1C2042;
  font-size: 40px;
  letter-spacing: -2.4px;
  line-height: 38px;
  cursor: pointer;
  background-color: #EFD6DB;
  padding: 0;
`;


// LARGE

export const ActionsButtonCircularLarge = styled.a`
  height: 89px;
  width: 89px;
  background-color: #1c2042;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 1260px){
    height: 64px;
    width: 64px;
  }
`;

export const ActionsButtonTextLarge = styled.a`
  color: #d1e0f5;
  font-size: 82px;
  letter-spacing: -2.58px;
  line-height: 30px;
  cursor: pointer;
  background-color: #1c2042;
  padding: 24px 0 35px 0;
  left: 192px;
  top: 107px;

  @media (max-width: 1260px){
    font-size: 61px;
    padding: 14px 0 25px 0;
  }
`;